export default "__VITE_ASSET__NhAaZD31__"